import { render } from "./ProductIdentifiers.vue?vue&type=template&id=36dd84ee&scoped=true"
import script from "./ProductIdentifiers.vue?vue&type=script&lang=js"
export * from "./ProductIdentifiers.vue?vue&type=script&lang=js"

import "./ProductIdentifiers.vue?vue&type=style&index=0&id=36dd84ee&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36dd84ee"]])

export default __exports__